import { useTranslation } from 'react-i18next';
import { Sun, Moon, Monitor } from 'lucide-react';
import { cn } from '../lib/cn';
import { useTheme, type ThemePreference } from '../theme/ThemeContext';

const OPTIONS: { value: ThemePreference; key: string; Icon: typeof Sun }[] = [
  { value: 'light', key: 'theme.light', Icon: Sun },
  { value: 'dark', key: 'theme.dark', Icon: Moon },
  { value: 'system', key: 'theme.system', Icon: Monitor },
];

/** `vertical` stacks the buttons (md+ only) — used in the collapsed sidebar rail. */
export function ThemeSwitcher({ vertical = false }: { vertical?: boolean }) {
  const { preference, setPreference } = useTheme();
  const { t } = useTranslation();
  return (
    <div
      role="group"
      aria-label={t('theme.label')}
      className={cn(
        'inline-flex items-center gap-0.5 rounded-md border border-border bg-muted/40 p-0.5',
        vertical && 'md:flex-col',
      )}
    >
      {OPTIONS.map(({ value, key, Icon }) => {
        const active = preference === value;
        return (
          <button
            key={value}
            type="button"
            onClick={() => setPreference(value)}
            aria-pressed={active}
            title={t(key)}
            className={cn(
              'inline-flex h-6 w-6 items-center justify-center rounded transition-colors',
              active
                ? 'bg-card text-foreground shadow-sm'
                : 'text-muted-foreground hover:text-foreground',
            )}
          >
            <Icon className="h-3.5 w-3.5" />
            <span className="sr-only">{t(key)}</span>
          </button>
        );
      })}
    </div>
  );
}
